var _defs, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg31Middle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 25,
    fill: "none",
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1660"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#99a7b4",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99a7b4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1654",
    x1: 0.996,
    x2: 7.914,
    y1: 11.268,
    y2: 11.321,
    gradientTransform: "matrix(.59479 0 0 .59479 8.922 4.786)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient1660"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeWidth: 0.779,
    d: "M0.806 1.662H5.263V24.371H0.806z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#99a7b4",
    fillOpacity: 1,
    strokeWidth: 1.338,
    d: "M5.263 1.662H18.41V24.371H5.263z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1654)",
    fillOpacity: 1,
    strokeWidth: 0.595,
    d: "M18.545 5.775H22.911V19.282H18.545z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002447",
    d: "M5.738 1.417L5.738 23.952"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002447",
    d: "M18.449 1.554L18.449 24.088"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002447",
    d: "M0.5 1.333H23.5V24.333H0.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg31Middle);
export default __webpack_public_path__ + "static/media/3.1_middle.393d31ee045276ef4c2599c813511aa2.svg";
export { ForwardRef as ReactComponent };